import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { IoIosCloseCircle, IoMdClose } from "react-icons/io";
import { Box, Button, Rating } from "@mui/material"
import Swal from "sweetalert2";
import { PacmanLoader } from "react-spinners";
import Multiselect from "multiselect-react-dropdown";
import { addAdmin, getAllPermissions, updatePermission } from "services/admin/adminService";
import { addBanner, updateBanner } from "services/admin/bannerService";
import { MdCloudUpload } from "react-icons/md";


const ModalBanner = ({ banner, onClose  }) => {
    const token = localStorage.getItem("token")
    const [isLoading, setIsLoading] = useState(false)
    const fileInputRef = useRef(null);

    const [fileUpload, setFileUpload] = useState(null) // lưu file ảnh upload để gửi lên server
    const [imageUpload, setImageUpload] = useState(banner ? banner.image : null) // lưu link ảnh từ server trả về để hiển thị ảnh

    const [modal, setModal] = useState(true);
    const [selectedBanner, setSelectedBanner] = useState();
    
    const toggleModal = (banner) => {
        setSelectedBanner(banner);
        setModal((prev) => !prev);
    };

    const [title, setTitle] = useState('');
    useEffect(() => {
        if (banner) {
            setTitle(banner.title);
        }
    }, [banner]);
    const [error, setError] = useState({fullNameError: '', phoneNumberError: ''});

    // const validateFullName = () => {
    //     const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/; // Kiểm tra kí tự đặc biệt
    //     const numberRegex = /\d/; // Kiểm tra có số k
      
    //     if (!title) {
    //         setError((prevError) => ({
    //             ...prevError,
    //             fullNameError: 'Họ và tên không được để trống',
    //         }));
    //     } 
    //     else if (specialCharRegex.test(title)) {
    //         setError((prevError) => ({
    //             ...prevError,
    //             fullNameError: 'Họ và tên không được chứa kí tự đặc biệt',
    //         }));
    //     } 
    //     else if (numberRegex.test(title)) {
    //         setError((prevError) => ({
    //             ...prevError,
    //             fullNameError: 'Họ và tên không được chứa số',
    //         }));
    //     } 
    //     else {
    //         setError((prevError) => ({
    //             ...prevError,
    //             fullNameError: '',
    //         }));
    //     }
    // };
      
    const handleAddBanner = async () => { 
        const formData = new FormData();
        formData.append('title', title);
        formData.append('image', fileUpload);

        try {
            setIsLoading(true);
            const response = await addBanner(token, formData);
            if (response.status === 200) {
                Swal.fire({
                    title: "Thêm banner thành công!",
                    text: `Admin đã được thêm mới`,
                    icon: "success"
                });
                onClose(true);
            } 
            else {
                Swal.fire({
                    title: "Thêm banner thất bại!",
                    text: `Vui lòng thử lại sau!`,
                    icon: "error"
                });
            }
        }
        catch (error) {
            console.log("Error adding banner:", error);
            Swal.fire({
                title: "Thêm banner thất bại!",
                text: `Vui lòng thử lại sau!`,
                icon: "error"
            });
        }
        finally {
            setIsLoading(false);
        }
    }

    const handleEditBanner = async () => { 
        const formData = new FormData();
        formData.append('title', title);
        if (fileUpload) {
            formData.append('image', fileUpload);
        }

        try {
            setIsLoading(true);
            const response = await updateBanner(token, banner.id, formData);
            if (response.status === 200) {
                Swal.fire({
                    title: "Cập nhật banner thành công!",
                    text: `Banner đã được cập nhật thành công`,
                    icon: "success"
                });
                onClose(true);
            } 
            else {
                Swal.fire({
                    title: "Cập nhật banner thất bại!",
                    text: `Vui lòng thử lại sau!`,
                    icon: "error"
                });
            }
        }
        catch (error) {
            console.log("updateBanner", error);
            Swal.fire({
                title: "Cập nhật banner thất bại!",
                text: `Vui lòng thử lại sau!`,
                icon: "error"
            });
        }
        finally {
            setIsLoading(false);
        }
    }
    const handleTitleChange = (event) => {
        setTitle(event.target.value);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileUpload(event.target.files[0])
            setImageUpload(URL.createObjectURL(file));
        }
    };


    return (
        <div className="modal_admin_manage">
            <div className="overlay_admin_manage">
                <div className="modal-content_admin_manage">
                <div
                    className="d-flex"
                    style={{
                        background: '#9d2ff7',
                        height: '50px',
                        margin: '-15px -28px 14px',
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                        position: 'relative', 
                        zIndex: 1,
                    }}
                >
                    <h5
                        className="w-100"
                        style={{
                            position: 'absolute',
                            color: 'white',
                            fontSize: '18px',
                            top: '50%',
                            left: '28px',    
                            transform: 'translateY(-50%)', 
                            margin: 0, 
                            zIndex: 10,
                        }}
                    >
                        {!banner ? 'Thêm mới banner' : 'Chỉnh sửa thông tin banner'}
                    </h5>
                    <IoMdClose
                        className="close-modal ms-auto"
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: '28px',
                            transform: 'translateY(-50%)',
                            zIndex: 10,
                            cursor: 'pointer',
                        }}
                        onClick={() => onClose(false)}
                    />
                    </div>
                    
                    <div className="">
                        <h4 className="mt-4">Tên banner</h4>
                        <input 
                            className="personal_infos"
                            type="text"
                            value={title}
                            onChange={handleTitleChange}
                            // onBlur={validateFullName}
                            placeholder="Nhập tên banner" 
                        />
                        <br />
                        {/* {error.fullNameError && <span style={{fontSize: '13px', color: 'red' }}>{error.fullNameError}</span>} */}

                        <h4 className="mt-3">Hình ảnh</h4>
                        {/* <input 
                            className="personal_infos"
                            type="file" accept="image/*" 
                            // onChange={banner ? null : handlePhoneChange}
                            // onBlur={validatePhoneNumber}
                            placeholder="Chọn hình ảnh"
                            onChange={handleFileChange} 
                        />
                        {imageUpload && (
                            <img src={imageUpload}  style={{ marginTop: '10px', width: "500px", maxHeight: "300px", objectFit: "contain" }}  alt=""/> 
                        )} */}
                        <div 
                            className="image_fileUpload"
                            style={{maxHeight: '300px !important'}}
                            onClick={() => document.querySelector(".input-image").click()}
                        >
                            <input 
                                type="file" accept="image/*" 
                                className="input-image" 
                                name="file" 
                                hidden
                                ref={fileInputRef}
                                onChange={handleFileChange} 
                            />
    
                            {imageUpload ? (
                                <img src={imageUpload}  style={{ maxWidth: "450px", maxHeight: "300px", objectFit: "contain" }}  alt=""/> 
                            ) : (
                                <>
                                    <MdCloudUpload color="#9d2ff7" size={100}/>
                                    <p>Chọn file để tải ảnh lên</p>
                                </>
                            )}
                        </div>
    

                        <Button 
                            className="add-btn ms-auto"
                            onClick={!banner ? handleAddBanner : handleEditBanner}
                        >
                            {!banner ? 'Xác nhận thêm' : 'Xác nhận chỉnh sửa'}
                        </Button>
                    </div>
                
                    
                </div>
            </div>
            {isLoading && (
                <div className="modal">
                    <div className="overlay_loading">
                        <div className="modal-content_loading">
                            <div className="d-flex">
                            <PacmanLoader color="#5e2e86"/>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
        </div>
    );
};

export default ModalBanner;
